import React from "react";

const HeroSection: React.FC = () => {
  return (
    <section className="hero hero-style pos-rel hero-video-hero">
      {/* Video FULL background */}
      <video
        className="hero-video-bg"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src="/videos/demoreel.mp4" type="video/mp4" />
      </video>

      {/* Overlay opcional para legibilidad */}
      <div className="hero-video-overlay" />

      <div className="container hero-foreground">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="hero-content">
            </div>
            {/* /hero-content */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
